export default "__VITE_ASSET__ClMBwqrv__"